import React from "react";
import Select from "../../../components/Input/Select";
import {areaTypeOptions} from "../Elements/Settings/Settings";

const AreaModal = ({handleChange, localSettings, error}) => {
    return (
        <>
            <Select
                label="Area type"
                handleChange={(selectedOption) => handleChange("areaType", selectedOption.value)}
                value={areaTypeOptions.find(option => option.value === (localSettings.areaType || "area-single"))}
                name="areaType"
                options={areaTypeOptions}
            />
            {error && <p className="error">{error}</p>}
        </>
    )
}

export default AreaModal;